import { useDeleteETSTicketNotificationMutation } from 'gcs-common/clients/api/entities/tickets/tickets-api';
import {
  useETSTicketsQueryParams,
  useSelectedETSTicketIdQueryParams,
} from 'gcs-common/clients/api/entities/tickets/tickets-api-helpers';
import { useGetETSTicketSelector } from 'gcs-common/clients/api/entities/tickets/tickets-api-selectors';
import { usePusherETSTicketsSubscription } from 'gcs-common/components/Tickets/usePusherETSTicketsSubscription';
import { getCurrentUserId } from 'gcs-common/slices/currentUser/currentUserSelectors';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import MaintenanceBanner from '../../../components/MaintenanceBanner/MaintenanceBanner';
import useEscKey from '../../../customHooks/useEscKey';
import TicketDetails from '../TicketDetails/TicketDetails';
import TicketForm from '../TicketForm/TicketForm';
import TicketDashboardFilters from './TicketDashboardFilters/TicketDashboardFilters';
import TicketDashboardHeader from './TicketDashboardHeader/TicketDashboardHeader';
import TicketDashboardTable from './TicketDashboardTable/TicketDashboardTable';
import styles from './styles.module.scss';

const TicketDashboard = () => {
  const currentUserId = useSelector(getCurrentUserId);
  const [showForm, setShowForm] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const { selectedTicketId, setSelectedTicketId } = useSelectedETSTicketIdQueryParams();
  const selectedTicket = useGetETSTicketSelector({ ticketId: selectedTicketId });
  const { setETSTicketsQueryParams } = useETSTicketsQueryParams();
  const deleteETSTicketNotification = useDeleteETSTicketNotificationMutation();
  useEffect(() => {
    if (selectedTicketId) {
      setShowDetails(true);
    }
  }, []);

  useEffect(() => {
    return () => {
      setETSTicketsQueryParams({}, true);
      setSelectedTicketId(undefined);
    };
  }, []);

  const closeDrawer = async () => {
    setShowForm(false);
    setShowDetails(false);

    if (selectedTicket?.hasNotifications) {
      await deleteETSTicketNotification.mutateAsync({ path: { id: selectedTicket.id } });
    }

    setSelectedTicketId(undefined);
  };

  useEscKey(closeDrawer);

  usePusherETSTicketsSubscription(currentUserId);

  return (
    <div className={styles.ticketDashboard}>
      <MaintenanceBanner />
      {(showDetails || showForm) && <div className={styles.overlay} onClick={closeDrawer} aria-hidden />}

      <TicketDashboardHeader />

      <TicketDashboardFilters setShowForm={setShowForm} />

      <TicketDashboardTable setShowDetails={setShowDetails} />

      {showForm && (
        <div className={styles.dashboardDrawer}>
          <TicketForm onClose={() => setShowForm(false)} />
        </div>
      )}

      {showDetails && selectedTicket && (
        <div className={styles.dashboardDrawer}>
          <TicketDetails ticket={selectedTicket} onClose={closeDrawer} />
        </div>
      )}
    </div>
  );
};

export default TicketDashboard;
